module.exports = __webpack_public_path__ + "static/media/down.97926c7d.jpg";